__turbopack_context__.v({
  "authorAvatar": "_8SV7vG_authorAvatar",
  "authorName": "_8SV7vG_authorName",
  "authorRole": "_8SV7vG_authorRole",
  "feedCard": "_8SV7vG_feedCard",
  "footer": "_8SV7vG_footer",
  "footerActions": "_8SV7vG_footerActions",
  "metaForum": "_8SV7vG_metaForum",
  "source": "_8SV7vG_source",
  "story": "_8SV7vG_story",
  "summary": "_8SV7vG_summary",
});
